<script setup>
/**
 * GoalProductGallery
 * Displays product images in a horizontal scrollable gallery
 */
import { ref } from 'vue'

defineProps({
  products: {
    type: Array,
    required: true,
    default: () => [],
  },
})

const fallbackImage = ref('/images/placeholder-product.png')

function handleImageError(event) {
  event.target.src = fallbackImage.value
}

function getProductImage(product) {
  // Prefer db_image if available
  if (product.db_image?.img) {
    return product.db_image.img
  }
  return product.image || fallbackImage.value
}
</script>

<template>
  <div class="product-gallery">
    <div v-for="product in products" :key="product.makat" class="product-item">
      <img :src="getProductImage(product)" :alt="product.name" @error="handleImageError" />
      <span class="product-makat">{{ product.makat }}</span>
    </div>
    <div v-if="products.length === 0" class="no-products">
      <span>אין מוצרים</span>
    </div>
  </div>
</template>

<style scoped>
.product-gallery {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
  overflow-x: auto;
  min-height: 80px;
  background: var(--bg-secondary);
}

.product-gallery::-webkit-scrollbar {
  height: 4px;
}

.product-gallery::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 2px;
}

.product-gallery::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 2px;
}

.product-item {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs);
}

.product-item img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: var(--border-radius-sm);
  background: var(--bg-primary);
}

.product-makat {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.no-products {
  width: 100%;
  text-align: center;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}
</style>
